<!-- Tabs -->
<div class="tabs-container">
  <div class="tabs-header">
    <div class="tabs-buttons">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'approved'"
        (click)="setActiveTab('approved')"
      >
        Approved
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'pending'"
        (click)="setActiveTab('pending')"
      >
        Pending
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'rejected'"
        (click)="setActiveTab('rejected')"
      >
        Rejected
      </button>
    </div>
    <div class="tabs-total">
      Total Count: <span class="tabs-total-value">{{ totalTabCount }}</span>
    </div>
  </div>
</div>

<!-- Expand Cell Template -->
<ng-template #publishAssetExpandCell let-row>
  <button
    type="button"
    class="hc-expand-btn"
    (click)="toggleRowExpansion(row)"
    [attr.aria-expanded]="isRowExpanded(row)"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [style.transform]="isRowExpanded(row) ? 'rotate(90deg)' : 'rotate(0deg)'"
      style="transition: transform 0.2s ease"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</ng-template>

<!-- Child Row Template -->
<ng-template #publishAssetChildRow let-row>
  <tr class="table--child-row">
    <td [attr.colspan]="publishAssetColumns.length" class="table--child-cell">
      <div class="hc-expand-detail">
        <div class="hc-expand-detail__inner">
          <div class="hc-expand-detail__grid">
            <div class="hc-expand-detail__card">
              <span class="hc-expand-detail__label">Uploaded by</span>
              <span class="hc-expand-detail__value">{{ row.originalData?.uploadedBy || 'N/A' }}</span>
            </div>
            <div class="hc-expand-detail__card">
              <span class="hc-expand-detail__label">Department</span>
              <span class="hc-expand-detail__value">{{ row.originalData?.department || 'N/A' }}</span>
            </div>
            <div class="hc-expand-detail__card hc-expand-detail__card--full">
              <div class="hc-expand-detail__card-split">
                <div class="hc-expand-detail__split-item">
                  <span class="hc-expand-detail__label">Industry</span>
                  <span class="hc-expand-detail__value">{{ row.originalData?.industry || 'N/A' }}</span>
                </div>
                <div class="hc-expand-detail__split-item">
                  <span class="hc-expand-detail__label">Organization</span>
                  <span class="hc-expand-detail__value">{{ row.originalData?.organization || 'N/A' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</ng-template>

<app-table
  [columns]="publishAssetColumns"
  [data]="publishAssetData"
  [pagination]="publishAssetPagination"
  [loading]="publishAssetLoading"
  [emptyMessage]="publishAssetEmptyMessage"
  [dropdownOpenRowIndex]="openPublishAssetDropdownRowIndex"
  [childRowTemplate]="publishAssetChildRowTemplate"
  [isRowExpanded]="getIsRowExpanded()"
  [initialSortColumn]="currentSort.field"
  [initialSortDirection]="currentSort.order"
  (pageChange)="onPublishAssetPageChange($event)"
  (pageSizeChange)="onPublishAssetPageSizeChange($event)"
  (sortChange)="onPublishAssetSortChange($event)"
>
  <!-- Permission column: chips with icon -->
  <ng-template #publishAssetPermissionCell let-row>
    <span [ngClass]="getPermissionChipClass(row.permission)" class="contribution-chip contribution-chip--with-icon">
      <img
        *ngIf="getPermissionIconKind(row.permission) === 'public'"
        src="/icons/globe-blue.svg"
        alt=""
        width="14"
        height="14"
        class="contribution-chip--permission-img"
      />
      <img
        *ngIf="getPermissionIconKind(row.permission) === 'restricted'"
        src="/icons/lock-blue.svg"
        alt=""
        width="14"
        height="14"
        class="contribution-chip--permission-img"
      />
      <img
        *ngIf="getPermissionIconKind(row.permission) === 'private'"
        src="/filters/lock.svg"
        alt=""
        width="14"
        height="14"
        class="contribution-chip--permission-img contribution-chip--permission-img-private"
      />
      <span>{{ getPermissionLabel(row.permission) }}</span>
    </span>
  </ng-template>
  <!-- Published On: DD-MMM-YYYY -->
  <ng-template #publishAssetPublishedOnCell let-row>
    {{ formatPublishedOn(row.publishedOn) }}
  </ng-template>
  <!-- Custom Action Column -->
  <ng-template #publishAssetActionCell let-row>
    <div class="action-cell-wrapper" [class.action-dropdown-open]="isDropdownOpen(row)">
      <button 
        class="action-btn action-btn--primary" 
        appActionDropdownTrigger
        (click)="toggleActionDropdown($event, row)"
        [class.active]="isDropdownOpen(row)"
        type="button"
      >
        <span class="action-btn-label">Action</span>
        <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      <div 
        class="action-dropdown-menu action-dropdown-menu--fixed" 
        *ngIf="isDropdownOpen(row)" 
        [style.top.px]="dropdownPosition.top"
        [style.left.px]="dropdownPosition.left"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item" *ngIf="showPublishAssetAction('view')">
            <button class="dropdown-link" (click)="handleAction('view', row)">View</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('approve')">
            <button class="dropdown-link" (click)="handleAction('approve', row)">Approve</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('reject')">
            <button class="dropdown-link" (click)="handleAction('reject', row)">Reject</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('modify')">
            <button class="dropdown-link" (click)="handleAction('modify', row)">Modify asset</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('delete')">
            <button class="dropdown-link" (click)="handleAction('delete', row)">Delete asset</button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</app-table>

<!-- Modify Asset Modal -->
<app-modal
  [(visible)]="showModifyModal"
  header="Modify Asset Metadata"
  [width]="'900px'"
  [showFooter]="false"
  (onCancel)="closeModifyModal()"
>
  <div *ngIf="isLoadingAssetData" class="loading-container">
    <p>Loading asset data...</p>
  </div>
  <app-provider-preview-metadata
    *ngIf="!isLoadingAssetData && modifyAssetData"
    [editableMode]="true"
    [allowSaveWithoutDirty]="true"
    [assetData]="modifyAssetData"
    [assetType]="getAssetTypeForModify()"
    (formSubmit)="onModifyFormSubmit($event)"
    (formCancel)="onModifyFormCancel()"
  ></app-provider-preview-metadata>
</app-modal>
